import React from 'react'
import Loadable from './Loadable'

import { createFunkGoPage } from './FunkGoPage'

export default function MyLoadable(opts, pluginHubFromOpts) {
  return Loadable(Object.assign({
    renderComponent(loaded, props) {
      return createFunkGoPage(loaded.default, pluginHubFromOpts || (props.staticContext && props.staticContext.pluginHub))
    },
    render(loaded, props, Component) {
      return <Component {...props}/>
    },
    loading: () => null,
    timeout: 10000,
  }, opts))
}

export function MyLoadableComponent(opts) {
  return Loadable(Object.assign({
    loading: () => null,
    timeout: 10000,
  }, opts))
}